import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

import { Component, TemplateRef, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { DialogConfig } from '../../models';
import { MdwDialogFooter } from '../footer/footer';
import { MdwDialogHeader } from '../header/header';

@Component({
  selector: 'mdw-dialog',
  imports: [MdwDialogHeader, MdwDialogFooter],
  templateUrl: './dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dialog.scss',
})
export class MdwDialog<T = boolean> {
  public dialogRef = inject(DialogRef<T>);
  // Passed in Data
  public _data = inject<DialogConfig>(DIALOG_DATA);

  public mainTitle = input<string>();
  public subTitle = input<string>();
  public customButtonHandlers = input<boolean>(false);
  public icon = input<string | TemplateRef<HTMLElement>>();
  public primaryButtonDisabled = input(false);
  public primaryButtonName = input<string>();
  public secondaryButtonDisabled = input(false);
  public secondaryButtonName = input<string>();
  public tertiaryButtonDisabled = input(false);
  public tertiaryButtonName = input<string>();
  public dangerButtonDisabled = input(false);
  public dangerButtonName = input<string>();
  public rightHeaderConent = input<TemplateRef<HTMLElement>>();
  public showCloseButton = input<boolean>(false);
  public hideFooter = input(false);
  public contentMaxHeight = input<number>();
  public showHeaderBorder = input(false);
  public customBodyPadding = input(false);
  public primaryButtonLoading = input(false);

  public primaryButtonClicked = output<void>();
  public secondaryButtonClicked = output<void>();
  public tertiaryButtonClicked = output<void>();
  public dangerButtonClicked = output<void>();

  public showHeader = computed(() => {
    return (
      this.mainTitle() ||
      this.data.title ||
      this.data.allowDismiss ||
      this.data.isBAM ||
      this.data.isFullPage
    );
  });

  public data = {
    primaryButton: this._data?.dangerButton ? undefined : 'OK',
    secondaryButton: 'Cancel',
    allowDismiss: false,
    showSecondaryButton: true,
    ...this._data,
  };

  public complete(status: boolean) {
    this.dialogRef.close(status as T);
  }
}
